import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine, faCheckCircle, faTimesCircle, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { Popover, OverlayTrigger } from 'react-bootstrap';

const safePct = v => { const n = parseFloat(v); return isNaN(n) ? 0 : n; };
const META = 90;

const colorSem = v => v >= META ? '#28a745' : v >= 80 ? '#fd7e14' : '#dc3545';
const labelSem = v => v >= META ? 'Cumple' : v >= 80 ? 'En riesgo' : 'No cumple';

const ResultadoRecaudacion = ({ recaudacion }) => {
  if (!recaudacion || recaudacion.length === 0)
    return <p className="text-muted mb-0">No hay datos de recaudación para el período seleccionado.</p>;

  return (
    <div className="table-responsive">
      <table className="table table-bordered mb-0" style={{ fontSize: 14 }}>
        <thead className="thead-light">
          <tr style={{ fontWeight: 600 }}>
            <th>Período</th>
            <th className="text-right">Programado</th>
            <th className="text-right">Cobrado</th>
            <th className="text-right">Pendiente</th>
            <th className="text-center" style={{ width: 150 }}>% Cobrado</th>
            <th className="text-center" style={{ width: 110 }}>Estado</th>
            <th className="text-center" style={{ width: 60 }}>Ver</th>
          </tr>
        </thead>
        <tbody>
          {recaudacion.map((dato, i) => {
            const v   = safePct(dato?.pagado?.porcentaje);
            const col = colorSem(v);
            const brecha = Math.max(0, META - v).toFixed(1);

            const popoverDesglose = (
              <Popover id={`popover-rec-${i}`}>
                <Popover.Title as="h6">Desglose de programado</Popover.Title>
                <Popover.Content>
                  <table className="table table-sm mb-0" style={{ fontSize: 12 }}>
                    <thead><tr><th>Descripción</th><th>Monto</th><th>%</th></tr></thead>
                    <tbody>
                      <tr>
                        <td>Activos</td>
                        <td>S/.{dato.activos?.monto || 0}</td>
                        <td>{safePct(dato.activos?.porcentaje)}%</td>
                      </tr>
                      <tr>
                        <td>Desertados</td>
                        <td>S/.{dato.perdida?.monto || 0}</td>
                        <td>{safePct(dato.perdida?.porcentaje)}%</td>
                      </tr>
                    </tbody>
                  </table>
                </Popover.Content>
              </Popover>
            );

            return (
              <tr key={i}>
                <td className="align-middle" style={{ fontWeight: 500 }}>
                  {dato.fecha_inicio} — {dato.fecha_fin}
                </td>
                <td className="text-right align-middle">
                  <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={popoverDesglose}>
                    <span style={{ cursor: 'pointer', color: '#007bff', textDecoration: 'underline dotted' }}>
                      S/. {dato.meta?.monto || 0}
                    </span>
                  </OverlayTrigger>
                </td>
                <td className="text-right align-middle">
                  <strong>S/. {dato.pagado?.monto || 0}</strong>
                </td>
                <td className="text-right align-middle text-danger">
                  S/. {dato.pendiente?.monto || 0}
                </td>
                <td className="text-center align-middle">
                  <div style={{ fontWeight: 700, fontSize: 20, color: col }}>{v}%</div>
                  <div className="progress mt-1" style={{ height: 5, borderRadius: 3 }}>
                    <div
                      className="progress-bar"
                      style={{ width: `${Math.min(100, v)}%`, backgroundColor: col, borderRadius: 3 }}
                    />
                  </div>
                  {v < META && (
                    <small style={{ color: '#aaa', fontSize: 11 }}>Brecha: {brecha}%</small>
                  )}
                </td>
                <td className="text-center align-middle">
                  <span style={{
                    fontSize: 12, fontWeight: 600, color: col,
                    backgroundColor: `${col}15`, padding: '3px 10px', borderRadius: 20,
                  }}>
                    {labelSem(v)}
                  </span>
                </td>
                <td className="text-center align-middle">
                  {dato.enlaceMeta && (
                    <a
                      href={dato.enlaceMeta}
                      className="btn btn-sm btn-outline-info"
                      rel="noopener noreferrer"
                      style={{ padding: '3px 8px' }}
                    >
                      <FontAwesomeIcon icon={faChartLine} />
                    </a>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ResultadoRecaudacion;
